import { fadeIn } from '@hellodarwin/core/lib/theme/keyframes';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';

export const OnboardingImageContainer = styled.div`
  padding: 16px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.purple_2};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow_high_contrast};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  aspect-ratio: 4/6;
  overflow: hidden;
  max-height: 700px;

  display: flex;

  margin-block: ${({ theme }) => theme.appearance.spacing * 5}px;
  margin-inline: ${({ theme }) => theme.appearance.spacing * 6}px;

  animation: ${fadeIn} 0.8s ease;

  ${media.l`
    max-width: 100%;
    max-height: 400px;
    margin:0;
  `}
`;

export const OnboardingImageContent = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  img {
    box-sizing: border-box;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
